import React, {useState, useCallback, useLayoutEffect} from "react";
import HttpAction from "modules/utils/HttpAction";

const RankingContext = React.createContext({
  state: { rankingList: [] },
  actions: {
    getRankingList: () => { },
    getRankingListByContest: () => { },
    setRankingList: () => { },
  },
});


const RankingProvider = ({ children }) => {
  const [rankingList, setRankingList] = useState();

  //랭킹 리스트 가져오기
  const getRankingList = useCallback((data) => {
    HttpAction({
      url: "/member/rank",
      method: "get",
      params: {
        page: data.page,
        records: data.records
      }
    }).then((res) => {
      if (res.code === 200) {
        console.log('res', res)
        setRankingList(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  const getRankingListByContest = useCallback((contestId) => {
    HttpAction({
      url: "/member/rank",
      method: "get",
      params: {
        page: 1,
        records: 5,
        contestId: contestId
      }
    }).then((res) => {
      if (res.code === 200) {
        // console.log('d', res.data)
        setRankingList(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  useLayoutEffect(() => {
    console.log('rankingContext')
    setRankingList([])
  }, [])

  const value = {
    state: { rankingList },
    actions: { getRankingList, getRankingListByContest, setRankingList },
  };

  return <RankingContext.Provider value={value}>{children}</RankingContext.Provider>;

};

const { Consumer: RankingConsumer } = RankingContext;

export { RankingProvider, RankingConsumer, RankingContext };

export default RankingContext;


